import { render, staticRenderFns } from "./AdminApprovalExpandedWidget.vue?vue&type=template&id=7fd2ff63"
import script from "./AdminApprovalExpandedWidget.vue?vue&type=script&lang=js"
export * from "./AdminApprovalExpandedWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports